import { createPortal } from 'react-dom';

/**
 * Modal isla clara Fit Live: confirmar reserva / replay antes de descontar tokens.
 */
export default function FitLiveSpendConfirmModal({
  open,
  title = 'Confirmar',
  classTitle = '',
  tokens = 0,
  balance = 0,
  busy = false,
  onCancel,
  onConfirm,
}) {
  if (!open || typeof document === 'undefined') return null;

  const cost = Math.max(0, Number(tokens) || 0);
  const saldo = Number(balance) || 0;
  const after = saldo - cost;
  const insufficient = cost > 0 && after < 0;

  return createPortal(
    <div className="fl-gate-overlay" role="presentation" onClick={() => !busy && onCancel?.()}>
      <div
        className="fl-gate-modal fl-spend-confirm"
        role="dialog"
        aria-modal="true"
        aria-labelledby="fl-spend-title"
        onClick={(ev) => ev.stopPropagation()}
      >
        <button
          type="button"
          className="fl-gate-close"
          onClick={() => !busy && onCancel?.()}
          aria-label="Cerrar"
        >
          ×
        </button>
        <p className="fl-gate-kicker">FIT LIVE · TOKENS</p>
        <h2 id="fl-spend-title">{title}</h2>
        {classTitle ? (
          <p className="fl-gate-lead">
            Clase:
            {' '}
            <strong>{classTitle}</strong>
          </p>
        ) : null}
        <div className="fl-spend-box">
          {cost <= 0 ? (
            <p className="m-0">Esta clase es gratis. No se descontarán tokens de tu saldo.</p>
          ) : (
            <p className="m-0">
              ¿Estás seguro? Se descontarán
              {' '}
              <strong>
                {cost}
                {' '}
                token
                {cost === 1 ? '' : 's'}
              </strong>
              {' '}
              de tu saldo.
            </p>
          )}
          <dl className="fl-spend-dl">
            <div>
              <dt>Tu saldo actual</dt>
              <dd>
                {saldo}
                {' '}
                tokens
              </dd>
            </div>
            {cost > 0 ? (
              <div>
                <dt>Saldo después</dt>
                <dd className={insufficient ? 'is-warn' : ''}>
                  {insufficient ? 'Insuficiente' : `${after} tokens`}
                </dd>
              </div>
            ) : null}
          </dl>
        </div>
        {insufficient ? (
          <p className="fl-spend-warn" role="alert">
            No tienes tokens suficientes. Compra un pack o pide cortesía al admin.
          </p>
        ) : null}
        <div className="fl-spend-actions">
          <button type="button" className="fl-btn" disabled={busy} onClick={() => onCancel?.()}>
            Cancelar
          </button>
          <button
            type="button"
            className="fl-btn fl-btn-primary"
            disabled={busy || insufficient}
            onClick={() => onConfirm?.()}
          >
            {busy ? 'Procesando…' : (cost > 0 ? 'Sí, continuar' : 'Continuar')}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
